import store from '@/store'

export default {
  // 二级解锁
  // 1、rentStatus = 29 仅沃恬使用，水量充值在小程序内操作；
  // 2、19987658：泽蛙仅品牌商显示
  // 3、19987736：印尼净水都不显示
  showSecUnlockBtn (appid, isBrand, rentStatus) {
    let isFlag = rentStatus != 29 && appid != 19987736 && (appid != 19987658 || isBrand)
    return isFlag
  },

  /**
   * 格式化货币显示（面向普通用户）
   * @param {number|string} amount - 货币金额
   * @param {string} currency - 币种代码 ('CNY', 'USD', 'IDR', 'SGD', 'VND')
   * @example
   * 为便于查看，去掉千分位隔符
   * formatCurrency('CNY', 6000)       // '¥6000.00'
   * formatCurrency('IDR', 6000)     // 'Rp 6000'
   * formatCurrency('VND', 6000)     // '6000 ₫'
   */
  formatCurrency (amount) {
    const currency = store.getters.metadata.currencyCode || 'CNY'
    // console.log('当前货币', currency, amount)
    const currencyConfig = {
      CNY: { locale: 'zh-CN', decimals: 2 },
      USD: { locale: 'en-US', decimals: 2 },
      IDR: { locale: 'id-ID', decimals: 0 },
      SGD: { locale: 'en-SG', decimals: 2 },
      VND: { locale: 'vi-VN', decimals: 0 }
    }
    const config = currencyConfig[currency] || currencyConfig.CNY
    if (amount === null || amount === undefined || amount === '') {
      return ''
    }
    const num = Number(amount)
    if (isNaN(num)) {
      return ''
    }
    // 可自动处理四舍五入、负数等情况，确保显示格式正确
    return new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: config.decimals,
      maximumFractionDigits: config.decimals,
      useGrouping: false
    }).format(num)
  }
}
